import api from '@app/services/api';
import type { ApiError, AIAgentViewParams, AIAgentViewResponse } from '@app/services/api.types';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<AIAgentViewResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchAgent = async ({ id }: AIAgentViewParams): Promise<AIAgentViewResponse> => {
    const url = apiEndpoints.aiAgents.getSingle(id);
    const response = await api.get(url);
    return response?.data?.data;
};

const useAgent = (params: AIAgentViewParams, options?: QueryOptions) => {
    return useQuery<AIAgentViewResponse, ApiError>({
        queryKey: ['ai-agent', 'single', params],
        queryFn: () => fetchAgent(params),
        ...options,
        enabled: Boolean(params.id),
    });
};

export default useAgent;
